import React from 'react';
import { usePreventScroll } from 'react-aria';
import * as S from './styles';
import { OverlayProps } from './types';

const Overlay = React.forwardRef<HTMLDivElement, OverlayProps>(
  (
    {
      allowClickthrough,
      children,
      className,
      onClick,
      onPointerDown,
      preventScrolling,
    },
    ref,
  ) => {
    usePreventScroll({ isDisabled: !preventScrolling });

    return (
      <S.Overlay
        {...{ className, onClick, onPointerDown, ref }}
        $allowClickthrough={!!allowClickthrough}
      >
        {children}
      </S.Overlay>
    );
  },
);

export default Overlay;
